module.exports = __webpack_public_path__ + "img/logo-sm.e1f5ade3.png";